import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAutoDispatchtoExternalSystems = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={346}
    height={121}
    fill="none"
    {...props}
  >
    <rect width={144} height={32} y={17} fill="#E9ECF0" rx={8} />
    <rect width={144} height={32} x={184} y={17} fill="#F2F5F7" rx={8} />
    <path
      fill="#363D4E"
      d="m39.86 29 2.081 6.297h.082L44.102 29h1.593l-2.82 8h-1.79l-2.816-8h1.59Zm6.827 8v-6H48.1v6zm.71-6.852c-.453 0-.82-.343-.82-.765 0-.426.367-.77.82-.77.45 0 .817.344.817.77 0 .422-.367.765-.816.765Zm4.775 6.97c-1.758 0-2.875-1.24-2.875-3.095 0-1.859 1.117-3.101 2.875-3.101s2.875 1.242 2.875 3.101c0 1.856-1.117 3.094-2.875 3.094Zm.008-1.134c.957 0 1.433-.867 1.433-1.965 0-1.097-.476-1.976-1.433-1.976-.973 0-1.45.879-1.45 1.977 0 1.097.477 1.964 1.45 1.964M57.66 29v8h-1.414v-8zm3.18 8.121c-1.144 0-2.007-.625-2.007-1.805 0-1.351 1.113-1.699 2.277-1.824 1.059-.113 1.485-.133 1.485-.539v-.023c0-.59-.36-.926-1.016-.926-.691 0-1.09.352-1.23.762l-1.32-.188c.312-1.094 1.28-1.656 2.542-1.656 1.145 0 2.438.476 2.438 2.062V37h-1.36v-.824h-.047c-.257.504-.82.945-1.761.945Zm.368-1.039c.851 0 1.39-.566 1.39-1.234v-.707c-.183.148-.925.242-1.296.293-.633.09-1.106.316-1.106.859 0 .52.422.789 1.012.789M68.428 31v1.094h-1.184v3.101c0 .57.285.696.64.696.177 0 .337-.035.415-.055l.238 1.105a2.8 2.8 0 0 1-.832.141c-1.062.031-1.883-.523-1.875-1.652v-3.336h-.852V31h.852v-1.438h1.414V31zm1.182 6v-6h1.414v6zm.711-6.852c-.453 0-.82-.343-.82-.765 0-.426.367-.77.82-.77.45 0 .817.344.817.77 0 .422-.368.765-.817.765m4.775 6.97c-1.758 0-2.875-1.24-2.875-3.095 0-1.859 1.117-3.101 2.875-3.101 1.757 0 2.875 1.242 2.875 3.101 0 1.856-1.118 3.094-2.875 3.094Zm.007-1.134c.958 0 1.434-.867 1.434-1.965 0-1.097-.477-1.976-1.434-1.976-.972 0-1.449.879-1.449 1.977 0 1.097.477 1.964 1.45 1.964Zm5.482-2.5V37h-1.414v-6h1.351v1.02h.07c.274-.668.891-1.098 1.79-1.098 1.238 0 2.058.82 2.054 2.258V37h-1.414v-3.602c0-.8-.437-1.28-1.168-1.28-.746 0-1.269.5-1.269 1.366m7.729-3.27V29h6.382v1.215h-2.472V37h-1.438v-6.785h-2.472ZM95.864 37v-6h1.414v6zm.711-6.852c-.453 0-.82-.343-.82-.765 0-.426.367-.77.82-.77.45 0 .817.344.817.77 0 .422-.368.765-.817.765m4.775 6.97c-1.793 0-2.875-1.278-2.875-3.095 0-1.832 1.109-3.101 2.867-3.101 1.465 0 2.48.855 2.578 2.156h-1.352c-.109-.578-.527-1.016-1.207-1.016-.871 0-1.453.727-1.453 1.938 0 1.227.571 1.965 1.453 1.965.621 0 1.086-.371 1.207-1.016h1.352c-.102 1.274-1.063 2.168-2.57 2.168Zm3.731-.118v-8h1.414v4.41h.098l2.156-2.41h1.652l-2.324 2.59 2.461 3.41h-1.691l-1.836-2.566-.516.55V37zm8.672.117c-1.809 0-2.914-1.199-2.914-3.082 0-1.851 1.121-3.113 2.84-3.113 1.476 0 2.742.926 2.742 3.031v.434h-4.18c.012 1.027.617 1.629 1.531 1.629.61 0 1.079-.266 1.27-.774l1.32.149c-.25 1.043-1.211 1.726-2.609 1.726m-1.508-3.683h2.82c-.007-.817-.554-1.41-1.367-1.41-.844 0-1.41.644-1.453 1.41M120.613 31v1.094h-1.183v3.101c0 .57.285.696.64.696.176 0 .336-.035.414-.055l.239 1.105c-.153.051-.43.13-.832.141-1.063.031-1.883-.523-1.875-1.652v-3.336h-.852V31h.852v-1.438h1.414V31zm105.375-2h1.203v5.672c-.003 1.539-.964 2.437-2.433 2.437-1.356 0-2.371-.757-2.371-2.109h1.199c.004.664.496 1.086 1.203 1.086.766 0 1.195-.492 1.199-1.414zm2.866 8v-6h1.168v6zm.59-6.926c-.406 0-.738-.312-.738-.695s.332-.7.738-.7c.403 0 .739.317.739.7s-.336.695-.739.695m2.15 6.926v-6h1.129v.953h.062c.219-.644.82-1.043 1.524-1.043.148 0 .379.012.496.027v1.118a2.8 2.8 0 0 0-.61-.07c-.828 0-1.433.566-1.433 1.35V37zm5.914.133c-1.141 0-2.028-.649-2.028-1.828 0-1.364 1.165-1.66 2.301-1.793 1.078-.125 1.516-.117 1.516-.543v-.028c0-.68-.387-1.074-1.141-1.074-.785 0-1.222.41-1.394.836l-1.098-.25c.391-1.094 1.391-1.531 2.477-1.531.953 0 2.328.348 2.328 2.094V37h-1.141v-.82h-.047c-.222.449-.781.953-1.773.953m.254-.938c.972 0 1.539-.648 1.539-1.36v-.773c-.168.169-1.067.27-1.446.32-.675.09-1.23.313-1.23.938 0 .578.477.875 1.137.875"
    />
    <circle cx={18} cy={33} r={12} fill="#427FF8" />
    <path
      fill="#fff"
      d="M18.6 28.8a4.2 4.2 0 1 1 0 8.4 4.2 4.2 0 0 1 0-8.4m-1.782 1.782a.45.45 0 1 0-.635.636l4.209 4.21a.45.45 0 0 0 .636-.637z"
    />
    <path
      fill="#fff"
      d="M16.53 27.33a4.2 4.2 0 0 1 2.171.605 4.98 4.98 0 0 0-4.796 6.873 4.2 4.2 0 0 1 2.625-7.477Zm.73 1.568"
    />
    <rect width={24} height={24} x={190} y={21} fill="#E0E3E9" rx={12} />
    <path
      fill="#2684FF"
      d="m208.249 32.646-5.71-5.516-.549-.53-4.281 4.137-1.958 1.891a.51.51 0 0 0 0 .725l3.916 3.784 2.323 2.263 4.282-4.137.074-.071 1.903-1.839a.49.49 0 0 0 0-.707m-6.259 2.245L200.033 33l1.957-1.892L203.948 33z"
    />
    <path
      fill="url(#AutoDispatchtoExternalSystems_svg__a)"
      d="M201.991 31.108a3.12 3.12 0 0 1-.019-4.49l-4.282 4.136L200.014 33l1.977-1.891Z"
    />
    <path
      fill="url(#AutoDispatchtoExternalSystems_svg__b)"
      d="m203.948 33-1.958 1.892c1.281 1.237 1.281 3.253 0 4.508l4.3-4.155z"
    />
    <rect width={144} height={32} x={184} y={53} fill="#F2F5F7" rx={8} />
    <rect width={41} height={4} x={222} y={67} fill="#C2C8D3" rx={2} />
    <rect width={24} height={24} x={190} y={57} fill="#E0E3E9" rx={12} />
    <path
      fill="#2684FF"
      d="m208.249 68.646-5.71-5.516-.549-.53-4.281 4.137-1.958 1.891a.51.51 0 0 0 0 .725l3.916 3.784 2.323 2.263 4.282-4.137.074-.071 1.903-1.839a.49.49 0 0 0 0-.707m-6.259 2.245L200.033 69l1.957-1.892L203.948 69z"
    />
    <path
      fill="url(#AutoDispatchtoExternalSystems_svg__c)"
      d="M201.991 67.108a3.12 3.12 0 0 1-.019-4.49l-4.282 4.136L200.014 69z"
    />
    <path
      fill="url(#AutoDispatchtoExternalSystems_svg__d)"
      d="m203.948 69-1.958 1.892c1.281 1.237 1.281 3.253 0 4.508l4.3-4.155z"
    />
    <circle cx={202} cy={69} r={7} fill="#C2C8D3" />
    <rect width={144} height={32} x={184} y={89} fill="#F2F5F7" rx={8} />
    <rect width={41} height={4} x={222} y={103} fill="#C2C8D3" rx={2} />
    <rect width={24} height={24} x={190} y={93} fill="#E0E3E9" rx={12} />
    <path
      fill="#2684FF"
      d="m208.249 104.646-5.71-5.516-.549-.53-4.281 4.137-1.958 1.891a.51.51 0 0 0 0 .725l3.916 3.784 2.323 2.263 4.282-4.137.074-.071 1.903-1.839a.49.49 0 0 0 0-.707m-6.259 2.245L200.033 105l1.957-1.892 1.958 1.892z"
    />
    <path
      fill="url(#AutoDispatchtoExternalSystems_svg__e)"
      d="M201.991 103.108a3.12 3.12 0 0 1-.019-4.49l-4.282 4.136 2.324 2.246z"
    />
    <path
      fill="url(#AutoDispatchtoExternalSystems_svg__f)"
      d="m203.948 105-1.958 1.892c1.281 1.237 1.281 3.253 0 4.508l4.3-4.155z"
    />
    <circle cx={202} cy={105} r={7} fill="#C2C8D3" />
    <g filter="url(#AutoDispatchtoExternalSystems_svg__g)">
      <rect width={53} height={18} x={283} y={8} fill="#fff" rx={3} />
      <path
        fill="#363D4E"
        d="M290.232 21.1c-1.471 0-2.522-.81-2.568-1.996h1.115c.043.646.657 1.05 1.445 1.05.856 0 1.471-.479 1.471-1.185 0-.732-.583-1.243-1.591-1.243h-.615v-.895h.615c.806 0 1.37-.462 1.367-1.165.003-.671-.483-1.122-1.225-1.122-.714 0-1.343.405-1.367 1.072h-1.062c.035-1.182 1.108-1.988 2.443-1.988 1.399 0 2.276.912 2.273 1.981.003.817-.49 1.414-1.25 1.609v.057c.966.149 1.523.81 1.52 1.73.003 1.207-1.087 2.094-2.571 2.094Zm3.927-.1v-5.454h1.026v.866h.057c.199-.586.746-.948 1.385-.948.135 0 .345.01.451.025v1.015a2.5 2.5 0 0 0-.554-.064c-.753 0-1.303.515-1.303 1.229V21zm5.685.107c-1.325 0-2.28-1.059-2.28-2.824 0-1.768.969-2.809 2.287-2.809 1.015 0 1.378.618 1.569.956h.064v-2.703h1.062V21h-1.037v-.849h-.089c-.191.348-.582.956-1.576.956m.234-.906c.916 0 1.424-.781 1.424-1.928 0-1.14-.497-1.897-1.424-1.897-.959 0-1.442.814-1.442 1.897 0 1.093.494 1.928 1.442 1.928m6.715.799v-7.273h2.592c1.691 0 2.518 1.016 2.518 2.355 0 1.342-.834 2.361-2.521 2.361h-1.492V21zm1.097-3.487h1.392c1.073 0 1.517-.608 1.517-1.431s-.444-1.414-1.531-1.414h-1.378zm6.753 3.608c-1.037 0-1.843-.59-1.843-1.662 0-1.24 1.058-1.51 2.092-1.63.98-.114 1.377-.107 1.377-.494v-.025c0-.617-.351-.976-1.037-.976-.713 0-1.111.373-1.267.76l-.998-.228c.355-.994 1.264-1.392 2.251-1.392.867 0 2.117.316 2.117 1.904V21h-1.037v-.746h-.043c-.202.409-.71.867-1.612.867m.231-.852c.884 0 1.399-.59 1.399-1.236v-.704c-.153.153-.97.246-1.314.292-.614.081-1.119.284-1.119.852 0 .526.434.796 1.034.796m3.875.731v-5.454h1.026v.866h.057c.199-.586.746-.948 1.385-.948.135 0 .344.01.451.025v1.015a2.5 2.5 0 0 0-.554-.064c-.753 0-1.303.515-1.303 1.229V21zm6.706-5.454v.852h-1.118v3c0 .615.309.728.653.728.171 0 .302-.032.373-.046l.192.877c-.125.047-.352.11-.689.114-.838.018-1.595-.462-1.591-1.452v-3.221h-.799v-.852h.799v-1.307h1.062v1.306h1.118Zm1.846 7.5c-.32 0-.597-.06-.724-.118l.255-.87c.583.16.963.1 1.232-.625l.132-.362-1.996-5.526h1.136l1.382 4.233h.057l1.381-4.232h1.14l-2.248 6.182c-.316.86-.87 1.317-1.747 1.317Z"
      />
    </g>
    <g filter="url(#AutoDispatchtoExternalSystems_svg__h)">
      <rect width={53} height={18} x={283} y={44} fill="#fff" rx={3} />
      <path
        fill="#363D4E"
        d="M290.232 57.1c-1.471 0-2.522-.81-2.568-1.996h1.115c.043.646.657 1.05 1.445 1.05.856 0 1.471-.479 1.471-1.185 0-.732-.583-1.243-1.591-1.243h-.615v-.895h.615c.806 0 1.37-.462 1.367-1.165.003-.671-.483-1.122-1.225-1.122-.714 0-1.343.405-1.367 1.073h-1.062c.035-1.183 1.108-1.99 2.443-1.99 1.399 0 2.276.913 2.273 1.982.003.817-.49 1.414-1.25 1.609v.057c.966.149 1.523.81 1.52 1.73.003 1.207-1.087 2.094-2.571 2.094Zm3.927-.1v-5.455h1.026v.867h.057c.199-.586.746-.948 1.385-.948.135 0 .345.01.451.025v1.015a2.5 2.5 0 0 0-.554-.064c-.753 0-1.303.515-1.303 1.229V57zm5.685.106c-1.325 0-2.28-1.058-2.28-2.823 0-1.768.969-2.809 2.287-2.809 1.015 0 1.378.618 1.569.956h.064v-2.703h1.062V57h-1.037v-.849h-.089c-.191.348-.582.955-1.576.955m.234-.905c.916 0 1.424-.781 1.424-1.928 0-1.14-.497-1.897-1.424-1.897-.959 0-1.442.814-1.442 1.897 0 1.093.494 1.928 1.442 1.928m6.715.799v-7.273h2.592c1.691 0 2.518 1.016 2.518 2.355 0 1.342-.834 2.361-2.521 2.361h-1.492V57zm1.097-3.487h1.392c1.073 0 1.517-.607 1.517-1.431s-.444-1.414-1.531-1.414h-1.378zm6.753 3.608c-1.037 0-1.843-.59-1.843-1.662 0-1.24 1.058-1.51 2.092-1.63.98-.114 1.377-.107 1.377-.494v-.025c0-.617-.351-.976-1.037-.976-.713 0-1.111.373-1.267.76l-.998-.227c.355-.995 1.264-1.393 2.251-1.393.867 0 2.117.317 2.117 1.904V57h-1.037v-.746h-.043c-.202.409-.71.867-1.612.867m.231-.852c.884 0 1.399-.59 1.399-1.236v-.703c-.153.152-.97.245-1.314.29-.614.082-1.119.285-1.119.853 0 .526.434.796 1.034.796m3.875.731v-5.455h1.026v.867h.057c.199-.586.746-.948 1.385-.948.135 0 .344.01.451.025v1.015a2.5 2.5 0 0 0-.554-.064c-.753 0-1.303.515-1.303 1.229V57zm6.706-5.455v.853h-1.118v3c0 .615.309.728.653.728.171 0 .302-.032.373-.046l.192.877c-.125.047-.352.11-.689.114-.838.018-1.595-.462-1.591-1.452v-3.221h-.799v-.853h.799V50.24h1.062v1.306zm1.846 7.5c-.32 0-.597-.06-.724-.117l.255-.87c.583.16.963.1 1.232-.625l.132-.362-1.996-5.526h1.136l1.382 4.233h.057l1.381-4.233h1.14l-2.248 6.183c-.316.86-.87 1.317-1.747 1.317"
      />
    </g>
    <g filter="url(#AutoDispatchtoExternalSystems_svg__i)">
      <rect width={53} height={18} x={283} y={80} fill="#fff" rx={3} />
      <path
        fill="#363D4E"
        d="M290.232 93.1c-1.471 0-2.522-.81-2.568-1.996h1.115c.043.646.657 1.05 1.445 1.05.856 0 1.471-.479 1.471-1.185 0-.732-.583-1.243-1.591-1.243h-.615v-.895h.615c.806 0 1.37-.462 1.367-1.165.003-.671-.483-1.122-1.225-1.122-.714 0-1.343.405-1.367 1.073h-1.062c.035-1.183 1.108-1.99 2.443-1.99 1.399 0 2.276.913 2.273 1.982.003.817-.49 1.414-1.25 1.609v.057c.966.149 1.523.81 1.52 1.73.003 1.207-1.087 2.094-2.571 2.094Zm3.927-.1v-5.454h1.026v.866h.057c.199-.586.746-.948 1.385-.948.135 0 .345.01.451.025v1.015a2.5 2.5 0 0 0-.554-.064c-.753 0-1.303.515-1.303 1.229V93zm5.685.106c-1.325 0-2.28-1.058-2.28-2.823 0-1.768.969-2.809 2.287-2.809 1.015 0 1.378.618 1.569.956h.064v-2.703h1.062V93h-1.037v-.849h-.089c-.191.348-.582.956-1.576.956Zm.234-.905c.916 0 1.424-.781 1.424-1.928 0-1.14-.497-1.897-1.424-1.897-.959 0-1.442.814-1.442 1.897 0 1.094.494 1.928 1.442 1.928m6.715.799v-7.273h2.592c1.691 0 2.518 1.016 2.518 2.355 0 1.342-.834 2.361-2.521 2.361h-1.492V93zm1.097-3.487h1.392c1.073 0 1.517-.608 1.517-1.431s-.444-1.414-1.531-1.414h-1.378zm6.753 3.608c-1.037 0-1.843-.59-1.843-1.662 0-1.24 1.058-1.51 2.092-1.63.98-.114 1.377-.107 1.377-.494v-.025c0-.618-.351-.976-1.037-.976-.713 0-1.111.373-1.267.76l-.998-.227c.355-.995 1.264-1.393 2.251-1.393.867 0 2.117.316 2.117 1.904V93h-1.037v-.746h-.043c-.202.409-.71.867-1.612.867m.231-.852c.884 0 1.399-.59 1.399-1.236v-.704c-.153.153-.97.246-1.314.292-.614.081-1.119.284-1.119.852 0 .526.434.796 1.034.796m3.875.731v-5.454h1.026v.866h.057c.199-.586.746-.948 1.385-.948.135 0 .344.01.451.025v1.015a2.5 2.5 0 0 0-.554-.064c-.753 0-1.303.515-1.303 1.229V93zm6.706-5.454v.852h-1.118v3c0 .615.309.728.653.728.171 0 .302-.032.373-.046l.192.877c-.125.047-.352.11-.689.114-.838.018-1.595-.462-1.591-1.452v-3.221h-.799v-.852h.799v-1.307h1.062v1.306h1.118Zm1.846 7.5c-.32 0-.597-.06-.724-.118l.255-.87c.583.16.963.1 1.232-.625l.132-.362-1.996-5.525h1.136l1.382 4.232h.057l1.381-4.233h1.14l-2.248 6.183c-.316.86-.87 1.318-1.747 1.318"
      />
    </g>
    <circle
      cx={144.5}
      cy={33.5}
      r={3.1}
      fill="#fff"
      stroke="#949EB2"
      strokeWidth={1.2}
    />
    <circle
      cx={184}
      cy={33.5}
      r={3.1}
      fill="#fff"
      stroke="#949EB2"
      strokeWidth={1.2}
    />
    <path
      fill="#949EB2"
      d="M172.403 28.903a.65.65 0 0 1 .92 0l4.137 4.137a.65.65 0 0 1 0 .92l-4.137 4.137a.651.651 0 0 1-.92-.92l3.466-3.466a.6.6 0 0 1-.037-.211.6.6 0 0 1 .037-.211l-3.466-3.466a.65.65 0 0 1 0-.92m-23.885 3.947a.65.65 0 0 1 0 1.3H148a.65.65 0 0 1 0-1.3zm3.625 0a.65.65 0 0 1 0 1.3h-1.036a.65.65 0 0 1 0-1.3zm3.625 0a.65.65 0 0 1 0 1.3h-1.036a.65.65 0 0 1 0-1.3zm3.625 0a.65.65 0 0 1 0 1.3h-1.036a.65.65 0 0 1 0-1.3zm3.625 0a.65.65 0 0 1 0 1.3h-1.036a.65.65 0 0 1 0-1.3zm3.625 0a.65.65 0 0 1 0 1.3h-1.036a.65.65 0 0 1 0-1.3zm3.625 0a.65.65 0 0 1 0 1.3h-1.036a.65.65 0 0 1 0-1.3zm3.625 0a.65.65 0 0 1 0 1.3h-1.036a.65.65 0 0 1 0-1.3z"
    />
    <defs>
      <linearGradient
        id="AutoDispatchtoExternalSystems_svg__a"
        x1={201.641}
        x2={199.001}
        y1={29.191}
        y2={31.924}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.176} stopColor="#0052CC" />
        <stop offset={1} stopColor="#2684FF" />
      </linearGradient>
      <linearGradient
        id="AutoDispatchtoExternalSystems_svg__b"
        x1={202.365}
        x2={205}
        y1={36.781}
        y2={34.054}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.176} stopColor="#0052CC" />
        <stop offset={1} stopColor="#2684FF" />
      </linearGradient>
      <linearGradient
        id="AutoDispatchtoExternalSystems_svg__c"
        x1={201.641}
        x2={199.001}
        y1={65.191}
        y2={67.924}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.176} stopColor="#0052CC" />
        <stop offset={1} stopColor="#2684FF" />
      </linearGradient>
      <linearGradient
        id="AutoDispatchtoExternalSystems_svg__d"
        x1={202.365}
        x2={205}
        y1={72.781}
        y2={70.054}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.176} stopColor="#0052CC" />
        <stop offset={1} stopColor="#2684FF" />
      </linearGradient>
      <linearGradient
        id="AutoDispatchtoExternalSystems_svg__e"
        x1={201.641}
        x2={199.001}
        y1={101.191}
        y2={103.924}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.176} stopColor="#0052CC" />
        <stop offset={1} stopColor="#2684FF" />
      </linearGradient>
      <linearGradient
        id="AutoDispatchtoExternalSystems_svg__f"
        x1={202.365}
        x2={205}
        y1={108.781}
        y2={106.054}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.176} stopColor="#0052CC" />
        <stop offset={1} stopColor="#2684FF" />
      </linearGradient>
      <filter
        id="AutoDispatchtoExternalSystems_svg__g"
        width={73}
        height={38}
        x={273}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={5} />
        <feColorMatrix values="0 0 0 0 0.0703125 0 0 0 0 0.0703125 0 0 0 0 0.104167 0 0 0 0.15 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_617_29814"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_617_29814"
          result="shape"
        />
      </filter>
      <filter
        id="AutoDispatchtoExternalSystems_svg__h"
        width={73}
        height={38}
        x={273}
        y={36}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={5} />
        <feColorMatrix values="0 0 0 0 0.0703125 0 0 0 0 0.0703125 0 0 0 0 0.104167 0 0 0 0.15 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_617_29814"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_617_29814"
          result="shape"
        />
      </filter>
      <filter
        id="AutoDispatchtoExternalSystems_svg__i"
        width={73}
        height={38}
        x={273}
        y={72}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={5} />
        <feColorMatrix values="0 0 0 0 0.0703125 0 0 0 0 0.0703125 0 0 0 0 0.104167 0 0 0 0.15 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_617_29814"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_617_29814"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default SvgAutoDispatchtoExternalSystems;
